import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cx } from "../lib/cx.js";
const toneClass = {
    brand: "evolua-badge",
    success: "evolua-badge evolua-badge--success",
    warning: "evolua-badge evolua-badge--warning",
    danger: "evolua-badge evolua-badge--danger",
    neutral: "evolua-badge evolua-badge--neutral",
    info: "evolua-badge evolua-badge--info",
};
const SUCCESS = /^(ACTIVE|APPROVED|COMPLETED|PUBLISHED|OK|ON|SUCCESS|DONE|ACEITO|VALIDATED)$/i;
const WARNING = /^(PENDING|WAITING|IN_PROGRESS|SCHEDULED|ON_LEAVE|DRAFT|ATRASADA|WARNING|IN_REVIEW|SUBMITTED|READY_FOR_HANDOFF|VACATION)$/i;
const DANGER = /^(REJECTED|CANCELLED|CANCELED|EXPIRED|FAILED|TERMINATED|INACTIVE|SUSPENDED|DENIED|ERROR|OFF|ACCESS_REVOKED)$/i;
export function badgeToneForStatus(status) {
    if (SUCCESS.test(status))
        return "success";
    if (WARNING.test(status))
        return "warning";
    if (DANGER.test(status))
        return "danger";
    return "neutral";
}
export function Badge({ children, tone = "brand", variant = "soft", size = "md", dot, className, ...rest }) {
    return (_jsxs("span", { className: cx(toneClass[tone], variant === "solid" && "evolua-badge--solid", variant === "outline" && "evolua-badge--outline", size === "sm" && "evolua-badge--sm", className), ...rest, children: [dot ? _jsx("span", { className: "evolua-badge__dot", "aria-hidden": "true" }) : null, children] }));
}
export function StatusBadge({ status, ...rest }) {
    return (_jsx(Badge, { tone: badgeToneForStatus(status), ...rest, children: status }));
}
//# sourceMappingURL=Badge.js.map